import { BRANCH_ENVIRONMENT_PRODUCTION } from '@takeshape/branches';
import type { ProjectSchemaCompat } from 'app/compat/types';
import { fromJS } from 'immutable';
import { setProjectSchema } from '../branches/actions.js';
import {
  type FetchSchemaRoutineMeta,
  type FetchSchemaRoutinePayload,
  fetchSchemaRoutine
} from '../branches/sagas/fetch-schema';
import { ContentState, handleContentRoutines } from '../common/utils/content-state.js';
import simpleReducer from '../common/utils/simple-reducer.js';
import { addLocale, removeLocale, setDefaultLocale } from './actions.js';
import type { LocalesState } from './types.js';

export const initialState = new ContentState();

export default simpleReducer(initialState, {
  ...handleContentRoutines([
    { routine: setDefaultLocale, type: 'mutation' },
    { routine: addLocale, type: 'mutation' },
    { routine: removeLocale, type: 'mutation' }
  ]),
  [`${setProjectSchema}`](state: LocalesState, { payload }: { payload: { schema: ProjectSchemaCompat } }) {
    const { defaultLocale, locales, version } = payload.schema;
    return state.merge({
      data: fromJS({ defaultLocale, locales, version }),
      loaded: true
    });
  },
  [`${fetchSchemaRoutine.fulfilled}`](
    state: LocalesState,
    { payload, meta }: { payload: FetchSchemaRoutinePayload; meta: FetchSchemaRoutineMeta }
  ) {
    const { branch } = meta;
    const schema = payload?.runtimeSchema ?? payload?.userSchema;

    if (branch !== BRANCH_ENVIRONMENT_PRODUCTION || !schema) {
      return state;
    }

    const { defaultLocale, locales, version } = schema;

    return state.merge({
      data: fromJS({ defaultLocale, locales, version }),
      loaded: true
    });
  }
});
